

































































































































































































































































































































































































































































































































































































































































































































import FileDrop                           from "@/components/FileDrop.vue";
import ValidatableCheckbox                from "@/components/pageGenerator/validatableInputs/ValidatableCheckbox.vue";
import ValidatableTextField               from "@/components/pageGenerator/validatableInputs/ValidatableTextField.vue";
import EventApi                           from "@/store/api/event";
import { IContributionResponse }          from "@/store/serverModels";
import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import { FieldScheme, InputFieldType }    from "./models";

@Component({
  name      : "InputFieldGenerator",
  components: {
    ValidatableCheckbox,
    FileDrop,
    ValidatableTextField
  }
})
export default class InputFieldGenerator extends Vue {
  private InputFieldType = InputFieldType;

  @Prop({
    required: true,
    type    : Object as () => FieldScheme,
    default : () => {
      return {};
    }
  })
  private field!: FieldScheme;

  @PropSync("fieldData")
  private fieldDataSynced!: unknown;
  private fileUploadSettings: unknown | undefined;

  private e1 = 1;

  private nameRules = [
    value => !!value || "Ce champs est obligatoire.",
    value => (value || "").length <= 25 || "25 caractères maximum"
  ];
  private requiredRules = [
    value => !!value || ""
  ];

  private textRules = [
    value => !!value || "Ce champs est obligatoire.",
    value => (value || "").length <= 150 || "150 caractères maximum"
  ];

  private imageRules = [
    value => !!value || "Ce champs est obligatoire."
  ];

  private senderEmailRules = [
    value => !!value || "Ce champs est obligatoire.",
    value => {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(value) || "E-Mail invalide.";
    }
  ];

  private recipientEmailRules = [
    value => {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return (!value || (value?.length > 0 && pattern.test(value))) || "E-Mail invalide.";
    }
  ];
  private contribution!: IContributionResponse;
  private imageUrl            = "";
  private validatedStepOne = false;

  created() {

    if (this.field.type === InputFieldType.File) {
      if (this.field.content != null) {
        this.fileUploadSettings = JSON.parse(this.field.content);
      }
    }
  }
  private nameFieldText="";
  private textFieldText="";
  private ecardContent="";
  private CguConsent = false;
  private DataConsent=false;
  private NewsletterConsent=false;
  private PublishConsent=false;

  private DataConsentReadMoreActivated=false;
  private NewsletterConsentReadMoreActivated=false;
  private PublishConsentReadMoreActivated=false;
  private dialog=false;

  private validateStepOne(e) {
    e.preventDefault();
    (this.$refs.FileInput as HTMLFormElement).validate()
    if ((this.$refs.formStep as HTMLFormElement).validate() && this.fieldDataSynced) {
      this.e1 = 2;
      console.log("FieldData: " + this.fieldDataSynced);

      var canvas     = this.$refs.ecardCanvas as HTMLCanvasElement;
      var context    = canvas.getContext("2d")as CanvasRenderingContext2D;
      var maxWidth   = 400;
      var lineHeight = 25;
      var x          = (canvas.width - maxWidth) / 2;
      var y          = 60;
      var text       = "All the world 's a stage, and all the men and women merely players. They have their exits and their entrances; And one man in his time plays many parts.";
      if (context) {
// Make it visually fill the positioned parent
        canvas.style.width  = "100%";
        canvas.style.height = "100%";
        // ...then set the internal size to match
        canvas.width        = 860;
        canvas.height       = 430;
        let backgroundImage = new Image();

        context.font      = "24pt Lato";
        context.fillStyle = "#fff";

        backgroundImage.onload = () => {
          context.drawImage(backgroundImage, 0, 0, 860, 430);

          let reader    = new FileReader();
          reader.onload = (e) => {
            let photoData = (e?.target?.result as string) || "";

            let photo    = new Image();
            photo.onload = () => {
              let rect = this.getCropImageRect(photo);
              context.drawImage(photo, rect.x, rect.y, rect.w, rect.h, 40, 92, 282, 282);

              var textHeight = this.wrapText(context, this.textFieldText, 365,150,480, 38);
              this.wrapText(context, this.nameFieldText, 365,textHeight + 38,480, 38);

              var d=canvas.toDataURL("image/png");
              this.ecardContent=d;
            };

            photo.src = photoData;
          };

          reader.readAsDataURL(this.fieldDataSynced as File); // convert to base64 string

        };
        backgroundImage.src    = "/img/sdl-ecard-background.png";
      }
    }
    this.validatedStepOne = true;
  }

  private getCropImageRect(photo: HTMLImageElement): { x: number, y: number, w: number, h: number } {
    let x      = 0;
    let y      = 0;
    let width  = photo.width;
    let height = photo.height;


    if (width > height) {
      x = (width - height) / 2;
      width = height;
    } else {
      y = (height - width) / 2;
      height = width;
    }
    return {x: x, y: y, w: width, h: height};
  }

  private wrapText(context: CanvasRenderingContext2D, text: string, x: number, y: number, maxWidth: number, lineHeight: number):number {
    var words = text.split(" ");
    var line  = "";

    for (var n = 0; n < words.length; n++) {
      var testLine  = line + words[n] + " ";
      var metrics   = context.measureText(testLine);
      var testWidth = metrics.width;
      if (testWidth > maxWidth && n > 0) {
        context.fillText(line, x, y);
        line = words[n] + " ";
        y += lineHeight;
      } else {
        line = testLine;
      }
    }
    context.fillText(line, x, y);
    return y+lineHeight;
  }
}
